import React from 'react';
import {useField} from 'formik';

import TestDate from '../test-date';
import Scores from '../scores';

const SatForm = () => {
  const [field] = useField('type');

  return (
    <>
      <TestDate />
      <Scores
        min={200}
        max={800}
        step={10}
        {...(field.value === 'sat' && {
          customRanges: {
            satScoreEssay: {
              min: 2,
              max: 12,
              step: 1,
            },
            satScoreMultipleChoice: {
              min: 20,
              max: 80,
              step: 1,
            },
          },
        })}
      />
    </>
  );
};

export default SatForm;
